import style from './style.module.scss'
import Img from "@shared/componets/ui/Img/Img";
import iconIformacionPersonal from './icons/informacionPersonal.svg'
import iconSeguridad from './icons/seguridad.svg'
import iconLogaut from './icons/logaut.svg'
import { Fragment } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@conductor/context/AuthContext';
import { usePerfilesContext } from '@conductor/context/PerfilesContext';
import perfiles from "@conductor/context/perfiles";
const SidebarPage = ({ sidebarActive, setSidevbarActive }) => {
	const { perfil } = usePerfilesContext();
	const { logOut } = useAuth();

	const sidebarItems = [
		{
			img: iconIformacionPersonal,
			title: 'Informacion personal',
			desc: 'Informacion de tu nombre, nro de legajo y CUIL.',
			callBack: false,
			link: '/informacion-personal',
		},
		// {
		// 	img: iconCuenta,
		// 	title: 'Datos de la Cuenta',
		// 	desc: 'Informacion de la cuenta de Comander PickUp.',
		// 	callBack: false,
		// 	link: '#',
		// },
		{
			img: iconSeguridad,
			title: 'Seguridad',
			desc: 'Configuracion de contraseñas.',
			callBack: false,
			link: '/seguridad',
		},
		// {
		// 	img: iconDirecciones,
		// 	title: 'Direcciones',
		// 	desc: 'Dirreciones guardadas de la cuenta.',
		// 	callBack: false,
		// 	link: '#',
		// },
		// {
		// 	img: iconPrivacidad,
		// 	title: 'Privacidad',
		// 	desc: 'Preferencias sobre el control y uso de tus datos.',
		// 	callBack: false,
		// 	link: '#',
		// },
	]


	// if (perfil === perfiles.CHOFER) {
	// 	sidebarItems.splice(sidebarItems.length - 1, 0, {
	// 		iconClasname: 'bi bi-boxes',
	// 		title: 'Items Asignados',
	// 		desc: 'Verifica y comfirma los items que tienes asignados.',
	// 		link: '/assigned-items',
	// 	});
	// }

	return (
		<section title='Opciones' className={`${style.contentSidebarPage} ${sidebarActive ? style.active : ''}`} >
			<h1 className="font-subtitle">Opciones</h1>
			<aside className={style.aside}>
				{sidebarItems.map((item, key) => (
					<Fragment key={`${key}-${item.link}`}>
						<ItemSidebarPage
							setSidevbarActive={setSidevbarActive}
							{...item}
						/>
					</Fragment>
				))}
				<ItemSidebarPage
					setSidevbarActive={setSidevbarActive}
					img={iconLogaut}
					title='Cerrar sesión'
					desc='Cierre sesión en este dispositivo.'
					callBack={logOut}
					link='/login'
				/>
			</aside>
		</section >
	)
}

export default SidebarPage;





const ItemSidebarPage = ({ title, img, iconClasname, desc, link, callBack, setSidevbarActive }) => {
	const navigate = useNavigate();


	const handleClick = () => {
		if (callBack) callBack()
		navigate(link);
		setSidevbarActive(false);
	}

	return (
		<div className={style.sidebarItem} onClick={handleClick}>
			{iconClasname && <i className={`${iconClasname} ${style.icon}`} />}
			{img && <Img variant="imgMax" src={img} alt={'imagen de ' + title} classNameContent={style.img} />}
			<h5>{title}</h5>
			<i className="bi bi-chevron-right" />
			<p className="font-main">{desc}</p>
		</div>
	)
}